import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import * as AdminActions from "../../../../actions/admin";

class SeasonSeats extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            report: 'club', // club, group, delegate, active-members
            seatsForSection: props.admin.generalSection ? (props.admin.generalSection.AntalMandaterSektioner === null ? '50' : String(props.admin.generalSection.AntalMandaterSektioner)) : '',
            seatsForMainBoard: props.admin.generalSection ? (props.admin.generalSection.AntalMandaterHovedbestyrelse === null ? '9' : String(props.admin.generalSection.AntalMandaterHovedbestyrelse)) : '',
            fromClub: '',
            toClub: '',
        });
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getGeneral());
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            seatsForSection: nextProps.admin.generalSection ? (nextProps.admin.generalSection.AntalMandaterSektioner === null ? '' : String(nextProps.admin.generalSection.AntalMandaterSektioner)) : '',
            seatsForMainBoard: nextProps.admin.generalSection ? (nextProps.admin.generalSection.AntalMandaterHovedbestyrelse === null ? '' : String(nextProps.admin.generalSection.AntalMandaterHovedbestyrelse)) : '',
        })
    }

    fields = [];
    render() {
        return <div className="season-seats reports-inner-box report-options">
            <table>
                <tbody>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}>
                            <input id="reportClub" name="report" type="radio" checked={this.state.report === 'club'} onClick={e => this.setState({report: 'club'})}/>
                        </td>
                        <td colSpan={2}>
                            <label htmlFor="reportClub">Pr. forening</label>
                        </td>
                    </tr>
                    <tr className="options-separator"/>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}>
                            <input id="reportGroup" name="report" type="radio" checked={this.state.report === 'group'} onClick={e => this.setState({report: 'group'})}/>
                        </td>
                        <td colSpan={2}>
                            <label htmlFor="reportGroup">Pr. gruppe</label>
                        </td>
                    </tr>
                    <tr className="options-separator"/>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}>
                            <input id="reportDelegate" name="report" type="radio" checked={this.state.report === 'delegate'} onClick={e => this.setState({report: 'delegate'})}/>
                        </td>
                        <td colSpan={2}>
                            <label htmlFor="reportDelegate">Delegeretmøde</label>
                        </td>
                    </tr>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}/>
                        <td style={{width: '250px'}}><label htmlFor="seatsForSection">Mandater til sektioner</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="seatsForSection" id="seatsForSection" value={this.state.seatsForSection}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[0] = instance; }}
                        /></td>
                    </tr>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}/>
                        <td style={{width: '250px'}}><label htmlFor="seatsForMainBoard">Mandater til hovedbestyrelsen</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="seatsForMainBoard" id="seatsForMainBoard" value={this.state.seatsForMainBoard}
                                              autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              ref={instance => { this.fields[1] = instance; }}
                        /></td>
                    </tr>
                    <tr className="options-separator"/>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}>
                            <input id="reportActiveMembers" name="report" type="radio" checked={this.state.report === 'active-members'} onClick={e => this.setState({report: 'active-members'})}/>
                        </td>
                        <td colSpan={2}>
                            <label htmlFor="reportActiveMembers">Sorter efter ringnummer</label>
                        </td>
                    </tr>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}/>
                        <td style={{width: '250px'}}><label htmlFor="fromClub">Fra forening</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="fromClub" id="fromClub" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.fromClub}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[2].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.fromClub)) this.setState({fromClub: this.state.fromClub.padStart(3, '0'), toClub: this.state.toClub === '' ? this.state.fromClub.padStart(3, '0') : this.state.toClub});
                                                  else if (/^[0-9]{3}$/.test(this.state.fromClub) && this.state.toClub === '') this.setState({toClub: this.state.fromClub});
                                              }}
                                              ref={instance => { this.fields[2] = instance; }}
                        /></td>
                    </tr>
                    <tr>
                        <td style={{maxWidth: '25px', width: '25px'}}/>
                        <td style={{width: '250px'}}><label htmlFor="toClub">Til forening</label></td>
                        <td><UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field-1 field100" containerClassName="display-inline-block"
                                              name="toClub" id="toClub" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.toClub}
                                              autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                              onChange={this.onStandardFieldChange}
                                              onBlur={() => {
                                                  this.fields[3].setState({focused: false, visited: true});
                                                  if (/^[0-9]{1,2}$/.test(this.state.toClub)) this.setState({toClub: this.state.toClub.padStart(3, '0')});
                                              }}
                                              ref={instance => { this.fields[3] = instance; }}
                        /></td>
                    </tr>
                </tbody>
            </table>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        const options = {
            report: this.state.report,
            seatsForSection: this.state.seatsForSection === '' ? null : Number(this.state.seatsForSection),
            seatsForMainBoard: this.state.seatsForMainBoard === '' ? null : Number(this.state.seatsForMainBoard),
            fromClub: this.state.fromClub === '' ? null : this.state.fromClub,
            toClub: this.state.toClub === '' ? null : this.state.toClub,
        };

        return {
            errors: errors,
            isErrors: !isValid,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    admin: {
        generalSection: state.admin.generalSection,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(SeasonSeats);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/SeasonSeats.js